import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry error tracking
Sentry.init({
  dsn: "https://514cad3e8ee41a9b66c087419e9d854b@o4509497075302400.ingest.us.sentry.io/4510466429943808",
  // Error tracking only - no performance tracing

  // Only enable in production/staging
  enabled: !window.location.hostname.includes('localhost'),

  // Filter out errors from browser extensions and third-party scripts
  ignoreErrors: [
    // Browser extension errors
    /extensions\//i,
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    // Common extension-related errors
    /ResizeObserver loop/,
    /Non-Error promise rejection/,
    // Network errors that aren't actionable
    /Network request failed/,
    /Failed to fetch/,
    /Load failed/,
  ],
  denyUrls: [
    // Browser extensions
    /extensions\//i,
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-extension:\/\//,
    // Common third-party scripts
    /googletagmanager\.com/,
    /google-analytics\.com/,
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
